// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__m5fQv","boxTitle":"Qualiphy_boxTitle__3hhHq","box":"Qualiphy_box__3D7v8","toggleWrap":"Qualiphy_toggleWrap__1MIud"};